export default __webpack_public_path__ + "static/media/smiley_rating_good.81f32c35.svg";